import { render, staticRenderFns } from "./Renderer.vue?vue&type=template&id=0849eced&"
import script from "./Renderer.vue?vue&type=script&lang=js&"
export * from "./Renderer.vue?vue&type=script&lang=js&"
import style0 from "./Renderer.vue?vue&type=style&index=0&id=0849eced&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports